import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getPermission, type PermissionsSlice } from './selectors';

export function usePermission(resource: string, action: string) {
  const selector = useCallback(
    (state: PermissionsSlice) => getPermission(state, { action, resource }),
    [action, resource]
  );
  return useSelector(selector);
}
